import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/auth.service";
import { DataServiceService } from "src/app/data-service.service";
import { User } from "../../model/login";
import { getSourceByField, SourceItem } from "../../utils/source-utils";
import { HttpClient } from "@angular/common/http";
import * as moment from "moment";

// 定义结构化结果类型
interface ResolutionItem {
  resolution: string;
  resolutionDate: string;
}

@Component({
  selector: "app-new-print-body",
  templateUrl: "./new-print-body.component.html",
  styleUrls: ["./new-print-body.component.scss"],
})
export class NewPrintBodyComponent implements OnInit {
  searchStringText;
  entityResult;
  nslEntityResult;
  pepResult: any[] = [];
  nslResult: any[] = [];
  sanctionResult: any[] = [];
  criminalsSearchResult: any[] = [];
  totalMatches;
  entityTotalMatches = 0;
  typeOfSearch = localStorage.getItem("searchType");
  searchedName = localStorage.getItem("searchedName");
  isAllDBSearch =
    localStorage.getItem("isAllDBSearch") == "true" ? true : false;
  isPepSearch = localStorage.getItem("isPepSearch") == "true" ? true : false;
  isHongKongSearch =
    localStorage.getItem("isHongKongSearch") == "true" ? true : false;
  isInternationalSearch =
    localStorage.getItem("isInternationalSearch") == "true" ? true : false;
  isIndividualSearch =
    localStorage.getItem("isIndividualSearch") == "true" ? true : false;
  isChineseSearch =
    localStorage.getItem("isChineseSearch") == "true" ? true : false;
  userDetails: User;
  isLoading: boolean = true;
  public hongKongDT;
  entityDD = "00";
  entityMM = "00";
  entityYYYY = "0000";
  entityGender = "NO";
  dailyCounterString = "0000";
  todayName = moment(new Date()).format("YYYYMMDD");
  showSuccessMsg: boolean = false;
  isSavingRecord: boolean = false;
  reportDateShow = "";

  // Resolution options
  resolutionOptions = ["--", "YES", "NO"];

  // Resolution status for each result type
  sanctionResolutions: { [key: number]: string } = {};
  pepResolutions: { [key: number]: string } = {};
  nslResolutions: { [key: number]: string } = {};
  criminalsResolutions: { [key: number]: string } = {};
  nslEntityResolutions: { [key: number]: string } = {};
  entityResolutions: { [key: number]: string } = {};

  // Resolution dates for each result type
  sanctionResolutionDates: { [key: number]: string } = {};
  pepResolutionDates: { [key: number]: string } = {};
  nslResolutionDates: { [key: number]: string } = {};
  criminalsResolutionDates: { [key: number]: string } = {};
  nslEntityResolutionDates: { [key: number]: string } = {};
  entityResolutionDates: { [key: number]: string } = {};

  // 结构化结果对象
  resolutionResults: {
    sanction: { [key: number]: ResolutionItem };
    pep: { [key: number]: ResolutionItem };
    nsl: { [key: number]: ResolutionItem };
    criminal: { [key: number]: ResolutionItem };
    nslEntity: { [key: number]: ResolutionItem };
    entity: { [key: number]: ResolutionItem };
  } = {
    sanction: {},
    pep: {},
    nsl: {},
    criminal: {},
    nslEntity: {},
    entity: {},
  };

  // Current date for default value
  currentDate = "";
  constructor(
    private route: ActivatedRoute,
    private dataService: DataServiceService,
    private authService: AuthService,
    private http: HttpClient
  ) {
    if (this.isIndividualSearch) {
      this.pepResult = JSON.parse(localStorage.getItem("pepSearchResult"));
      this.nslResult = JSON.parse(localStorage.getItem("nslSearchResult"))[
        "found_records"
      ];
      this.sanctionResult = JSON.parse(
        localStorage.getItem("sanctionSearchResult")
      );
      this.criminalsSearchResult = JSON.parse(
        localStorage.getItem("criminalsSearchResult")
      );
      this.getDataFromLocalStorage();
    } else {
      this.isSavingRecord = false; // 在失败时也需要重置保存状态
      this.entityResult = JSON.parse(
        localStorage.getItem("entitySearchResult")
      );
      this.nslEntityResult = JSON.parse(
        localStorage.getItem("nslEntitySearchResult")
      );
      // 计算 Entity 搜索的总匹配数
      const entityCount = this.entityResult?.found_records?.length || 0;
      const nslEntityCount = this.nslEntityResult?.found_records?.length || 0;
      this.entityTotalMatches = entityCount + nslEntityCount;
      // 获取 Entity 搜索的 dailyCounter
      this.getDataFromLocalStorage();
    }
    console.log("this.pepResult", this.pepResult);
    console.log("this.nslResult", this.nslResult);
    console.log("this.sanctionResult", this.sanctionResult);
    console.log("this.criminalsSearchResult", this.criminalsSearchResult);
    this.totalMatches =
      this.sanctionResult.length +
      this.pepResult.length +
      this.criminalsSearchResult.length +
      (this.nslResult ? this.nslResult.length : 0);
    this.handleCriminalsSearchResult();

    // Initialize resolutions
    if (this.sanctionResult) {
      this.sanctionResult.forEach((item, index) => {
        this.sanctionResolutions[index] = "--";
        this.sanctionResolutionDates[index] = "";
        this.resolutionResults.sanction[index] = {
          resolution: "--",
          resolutionDate: "",
        };
        // 直接存储在sanctionResult对象中
        item.resolution = "--";
        item.resolutionDate = "";
      });
    }

    if (this.pepResult) {
      this.pepResult.forEach((item, index) => {
        this.pepResolutions[index] = "--";
        this.pepResolutionDates[index] = "";
        this.resolutionResults.pep[index] = {
          resolution: "--",
          resolutionDate: "",
        };
        // 直接存储在pepResult对象中
        item.resolution = "--";
        item.resolutionDate = "";
      });
    }

    if (this.nslResult) {
      this.nslResult.forEach((item, index) => {
        this.nslResolutions[index] = "--";
        this.nslResolutionDates[index] = "";
        this.resolutionResults.nsl[index] = {
          resolution: "--",
          resolutionDate: "",
        };
        // 直接存储在nslResult对象中
        item.resolution = "--";
        item.resolutionDate = "";
      });
    }

    if (this.criminalsSearchResult) {
      this.criminalsSearchResult.forEach((item, index) => {
        this.criminalsResolutions[index] = "--";
        this.criminalsResolutionDates[index] = "";
        this.resolutionResults.criminal[index] = {
          resolution: "--",
          resolutionDate: "",
        };
        // 直接存储在criminalsSearchResult对象中
        item.resolution = "--";
        item.resolutionDate = "";
      });
    }

    // Initialize nslEntity resolutions
    if (this.nslEntityResult && this.nslEntityResult.found_records) {
      this.nslEntityResult.found_records.forEach((item, index) => {
        this.nslEntityResolutions[index] = "--";
        this.nslEntityResolutionDates[index] = "";
        this.resolutionResults.nslEntity[index] = {
          resolution: "--",
          resolutionDate: "",
        };
        // 直接存储在nslEntityResult对象中
        item.resolution = "--";
        item.resolutionDate = "";
      });
    }

    // Initialize entity resolutions
    if (this.entityResult && this.entityResult.found_records) {
      this.entityResult.found_records.forEach((item, index) => {
        this.entityResolutions[index] = "--";
        this.entityResolutionDates[index] = "";
        this.resolutionResults.entity[index] = {
          resolution: "--",
          resolutionDate: "",
        };
        // 直接存储在entityResult对象中
        item.resolution = "--";
        item.resolutionDate = "";
      });
    }
  }

  ngOnInit(): void {
    // 设置当前日期，用于限制日期选择器的最大值
    this.currentDate = new Date().toISOString().split("T")[0]; // 格式为 YYYY-MM-DD

    this.hongKongDT = localStorage.getItem("searchDateAndTime");
    this.reportDateShow = moment().format("DD/MM/YYYY HH:mm:ss");
    console.log("this.reportDateShow", this.reportDateShow);

    if (this.isIndividualSearch) {
      this.searchStringText =
        this.typeOfSearch != "advance"
          ? `NEW QUICK SEARCH RESULTS FOR ${this.searchedName}`
          : `NEW ADVANCE SEARCH RESULTS FOR ${this.searchedName}`;
    } else {
      this.searchStringText = `NEW ENTITY SEARCH RESULTS FOR ${this.searchedName}`;
    }
    this.getUserDetails().then((data) => {
      this.isLoading = false;
    });
  }

  async handleCriminalsSearchResult() {
    console.log("handleCriminalsSearchResult");
    if (this.criminalsSearchResult && this.criminalsSearchResult.length > 0) {
      for (let index = 0; index < this.criminalsSearchResult.length; index++) {
        const element = this.criminalsSearchResult[index];
        element.sourceInfo = await getSourceByField(
          element.source_id,
          this.http
        );
        console.log("element.sourceInfo", element.sourceInfo);
      }
    }
  }

  async getUserDetails() {
    this.userDetails = await this.dataService.getUserDetailsById(
      this.authService.getCurrentUser().userId
    );
    this.userDetails = this.userDetails[0];
    console.log("new-print-body.component userDetails", this.userDetails);
  }

  getDataFromLocalStorage() {
    this.entityDD = localStorage.getItem("dd")
      ? localStorage.getItem("dd")
      : "00";
    this.entityMM = localStorage.getItem("mm")
      ? localStorage.getItem("mm")
      : "00";
    this.entityYYYY = localStorage.getItem("yyyy")
      ? localStorage.getItem("yyyy")
      : "0000";
    this.entityGender = localStorage.getItem("gender")
      ? localStorage.getItem("gender")
      : "NO";
    this.dailyCounterString =
      localStorage.getItem("dailyCounter") &&
      parseInt(localStorage.getItem("dailyCounter")) > 0
        ? this.formatDailyCounter(
            parseInt(localStorage.getItem("dailyCounter"))
          )
        : "0000";
  }

  /**
   * Formats a number as a 4-digit string with leading zeros
   * @param counter The number to format (e.g., 0, 1, 42, etc.)
   * @returns A 4-digit string with leading zeros (e.g., "0000", "0001", "0042", etc.)
   */
  formatDailyCounter(counter: number): string {
    // Convert the number to string and pad with leading zeros to make it 4 digits
    return counter.toString().padStart(4, "0");
  }

  saveRecord() {
    // 如果已经在保存记录中，则直接返回，防止重复点击
    if (this.isSavingRecord) {
      console.log("Save in progress, ignoring duplicate request");
      return;
    }
    console.log("saveRecord");
    this.isSavingRecord = true;
    var currentDate = new Date();

    var historyObj = {};

    historyObj["userEmail"] = this.userDetails.email;
    let recordJson = {
      pepResult: this.pepResult,
      nslResult: this.nslResult,
      sanctionResult: this.sanctionResult,
      criminalsSearchResult: this.criminalsSearchResult,
      entityResult: this.entityResult,
      nslEntityResult: this.nslEntityResult,
      totalMatches: this.isIndividualSearch
        ? this.totalMatches
        : this.entityTotalMatches,
      typeOfSearch: this.typeOfSearch,
      searchedName: this.searchedName,
      hongKongDT: this.hongKongDT,
      entityGender: this.entityGender,
      entityDD: this.entityDD,
      entityMM: this.entityMM,
      entityYYYY: this.entityYYYY,
      dailyCounterString: this.dailyCounterString,
      todayName: this.todayName,
      resolutionResults: this.resolutionResults,
      isIndividualSearch: this.isIndividualSearch,
    };
    recordJson["saveDate"] = moment(
      this.reportDateShow,
      "DD/MM/YYYY HH:mm:ss"
    ).format("DD/MM/YYYY");
    recordJson["saveTime"] = moment(
      this.reportDateShow,
      "DD/MM/YYYY HH:mm:ss"
    ).format("HH:mm:ss");
    recordJson["UTCsaveDate"] = `${currentDate.getUTCDate()}/${
      currentDate.getUTCMonth() + 1
    }/${currentDate.getUTCFullYear()}`;
    recordJson[
      "UTCsaveTime"
    ] = `${currentDate.getUTCHours()}:${currentDate.getUTCMinutes()}:${currentDate.getUTCSeconds()}`;
    recordJson["type"] = "REPORT";

    historyObj["historyData"] = [recordJson];
    console.log("historyObj", historyObj);
    this.dataService
      .saveSearchResult(historyObj)
      .then((data) => {
        if (data["msg"] == "Saved record") {
          this.isSavingRecord = false;
          this.showSuccessMsg = true;
          setTimeout(() => {
            this.showSuccessMsg = false;
          }, 5000);
        } else {
          this.isSavingRecord = false; // 在失败时也需要重置保存状态
          alert("Failed to save record. Please try after some time");
        }
      })
      .catch((error) => {
        console.error("Error saving record:", error);
        this.isSavingRecord = false; // 发生错误时重置保存状态
        if (error && error.statusText) {
          if (error.statusText.indexOf("Too Large") > -1) {
            alert(
              "The search report file is too large to save in iKYC, we suggest you print or save the report in your local drive, should you have any questions, please feel tree to contact us at info@kcgleads.com, we will get back to you within 24 hours"
            );
          } else {
            alert(error.statusText);
          }
        } else {
          alert("An error occurred while saving. Please try again later.");
        }
      });
  }

  /**
   * Change the resolution status for a specific result
   * @param type The type of result ('sanction', 'pep', 'criminal')
   * @param index The index of the result
   * @param value The new resolution value
   */
  changeResolution(type: string, index: number, value: string): void {
    console.log(`Changing ${type} resolution at index ${index} to ${value}`);

    switch (type) {
      case "sanction":
        this.sanctionResolutions[index] = value;
        this.resolutionResults.sanction[index].resolution = value;
        // 直接存储在sanctionResult对象中
        this.sanctionResult[index].resolution = value;

        // 如果选择了"NO"或"--"，清空日期值
        if (value === "NO" || value === "--") {
          this.sanctionResolutionDates[index] = "";
          this.resolutionResults.sanction[index].resolutionDate = "";
          this.sanctionResult[index].resolutionDate = "";
        }
        break;
      case "pep":
        this.pepResolutions[index] = value;
        this.resolutionResults.pep[index].resolution = value;
        // 直接存储在pepResult对象中
        this.pepResult[index].resolution = value;

        // 如果选择了"NO"或"--"，清空日期值
        if (value === "NO" || value === "--") {
          this.pepResolutionDates[index] = "";
          this.resolutionResults.pep[index].resolutionDate = "";
          this.pepResult[index].resolutionDate = "";
        }
        break;
      case "nsl":
        this.nslResolutions[index] = value;
        this.resolutionResults.nsl[index].resolution = value;
        // 直接存储在nslResult对象中
        this.nslResult[index].resolution = value;

        // 如果选择了"NO"或"--"，清空日期值
        if (value === "NO" || value === "--") {
          this.nslResolutionDates[index] = "";
          this.resolutionResults.nsl[index].resolutionDate = "";
          this.nslResult[index].resolutionDate = "";
        }
        break;
      case "criminal":
        this.criminalsResolutions[index] = value;
        this.resolutionResults.criminal[index].resolution = value;
        // 直接存储在criminalsSearchResult对象中
        this.criminalsSearchResult[index].resolution = value;

        // 如果选择了"NO"或"--"，清空日期值
        if (value === "NO" || value === "--") {
          this.criminalsResolutionDates[index] = "";
          this.resolutionResults.criminal[index].resolutionDate = "";
          this.criminalsSearchResult[index].resolutionDate = "";
        }
        break;
      case "nslEntity":
        this.nslEntityResolutions[index] = value;
        this.resolutionResults.nslEntity[index].resolution = value;
        // 直接存储在nslEntityResult对象中
        this.nslEntityResult.found_records[index].resolution = value;

        // 如果选择了"NO"或"--"，清空日期值
        if (value === "NO" || value === "--") {
          this.nslEntityResolutionDates[index] = "";
          this.resolutionResults.nslEntity[index].resolutionDate = "";
          this.nslEntityResult.found_records[index].resolutionDate = "";
        }
        break;
      case "entity":
        this.entityResolutions[index] = value;
        this.resolutionResults.entity[index].resolution = value;
        // 直接存储在entityResult对象中
        this.entityResult.found_records[index].resolution = value;

        // 如果选择了"NO"或"--"，清空日期值
        if (value === "NO" || value === "--") {
          this.entityResolutionDates[index] = "";
          this.resolutionResults.entity[index].resolutionDate = "";
          this.entityResult.found_records[index].resolutionDate = "";
        }
        break;
    }

    // 记录当前所有结果
    console.log("Sanction Result:", this.sanctionResult);
    console.log("PEP Result:", this.pepResult);
    console.log("NSL Result:", this.nslResult);
    console.log("Criminals Result:", this.criminalsSearchResult);
    console.log("NSL Entity Result:", this.nslEntityResult);
    console.log("Entity Result:", this.entityResult);
  }

  /**
   * Change the resolution date for a specific result
   * @param type The type of result ('sanction', 'pep', 'criminal')
   * @param index The index of the result
   * @param date The new date value
   */
  changeResolutionDate(type: string, index: number, date: string): void {
    console.log(
      `Changing ${type} resolution date at index ${index} to ${date}`
    );

    switch (type) {
      case "sanction":
        this.sanctionResolutionDates[index] = date;
        this.resolutionResults.sanction[index].resolutionDate = date;
        // 直接存储在sanctionResult对象中
        this.sanctionResult[index].resolutionDate = date;
        break;
      case "pep":
        this.pepResolutionDates[index] = date;
        this.resolutionResults.pep[index].resolutionDate = date;
        // 直接存储在pepResult对象中
        this.pepResult[index].resolutionDate = date;
        break;
      case "nsl":
        this.nslResolutionDates[index] = date;
        this.resolutionResults.nsl[index].resolutionDate = date;
        // 直接存储在nslResult对象中
        this.nslResult[index].resolutionDate = date;
        break;
      case "criminal":
        this.criminalsResolutionDates[index] = date;
        this.resolutionResults.criminal[index].resolutionDate = date;
        // 直接存储在criminalsSearchResult对象中
        this.criminalsSearchResult[index].resolutionDate = date;
        break;
      case "nslEntity":
        this.nslEntityResolutionDates[index] = date;
        this.resolutionResults.nslEntity[index].resolutionDate = date;
        // 直接存储在nslEntityResult对象中
        this.nslEntityResult.found_records[index].resolutionDate = date;
        break;
      case "entity":
        this.entityResolutionDates[index] = date;
        this.resolutionResults.entity[index].resolutionDate = date;
        // 直接存储在entityResult对象中
        this.entityResult.found_records[index].resolutionDate = date;
        break;
    }

    // 记录当前所有结果
    console.log("Sanction Result:", this.sanctionResult);
    console.log("PEP Result:", this.pepResult);
    console.log("NSL Result:", this.nslResult);
    console.log("Criminals Result:", this.criminalsSearchResult);
    console.log("NSL Entity Result:", this.nslEntityResult);
    console.log("Entity Result:", this.entityResult);
  }

  /**
   * 获取所有Resolution结果
   * 在保存记录时可以调用此方法获取完整的结果数据
   */
  getAllResolutionResults() {
    return this.resolutionResults;
  }
}
